export const MATCH_ADDED = 'MATCH_ADDED'
export const MATCH_CHANGED = 'MATCH_CHANGED'
export const MATCH_MOVED = 'MATCH_MOVED'
export const MATCH_REMOVED = 'MATCH_REMOVED'
export const MATCH_UPDATE = 'MATCH_UPDATE'
